import { keys } from './keys';
import { methods } from './methods';
import { statuses } from './statuses';
import { urls } from './urls';

export const apiKeys = { ...keys };
export const apiMethods = { ...methods };
export const apiStatuses = { ...statuses };
export const apiUrls = { ...urls };
